const es = {
  // Navbar
  "nav.home": "Inicio",
  "nav.about": "Nosotros",
  "nav.presentations": "Presentaciones",
  "nav.catalog": "Catálogo",
  "nav.benefits": "Beneficios",
  "nav.locations": "Puntos de venta",
  "nav.contact": "Contacto",

  // Hero
  "hero.title": "El auténtico yogurt griego que transforma lo natural en un momento extraordinario.",
  "hero.subtitle": "Elaborado artesanalmente en Costa Rica con ingredientes seleccionados, alto en proteína, deslactosado y pensado para disfrutar cada cucharada.",
  "hero.cta_catalog": "Ver Catálogo",
  "hero.cta_locations": "Dónde Encontrarnos",

  // Benefits
  "benefits.title": "Beneficios que se sienten",
  "benefits.protein": "Alto en proteína",
  "benefits.protein_desc": "Hasta 7g de proteína por porción para una alimentación balanceada.",
  "benefits.lactose_free": "Deslactosado",
  "benefits.lactose_free_desc": "Disfruta sin preocupaciones. Ideal para personas con intolerancia a la lactosa.",
  "benefits.no_sugar": "Sin azúcar añadida",
  "benefits.no_sugar_desc": "Endulzado naturalmente. Sin azúcares refinados ni edulcorantes artificiales.",
  "benefits.cultures": "Cultivos vivos",
  "benefits.cultures_desc": "Probióticos naturales que favorecen la salud digestiva y fortalecen el sistema inmune.",
  "benefits.costa_rica": "Hecho en Costa Rica",
  "benefits.costa_rica_desc": "Producción 100% costarricense. Apoyamos el talento y los ingredientes locales.",
  "benefits.artisanal": "Producción artesanal",
  "benefits.artisanal_desc": "Elaborado en pequeños lotes con dedicación, cuidado y atención al detalle.",

  // About
  "about.title": "Nuestra historia",
  "about.subtitle": "Desde Costa Rica, elaboramos yogurt griego artesanal con los más altos estándares de calidad.",
  "about.paragraph1": "Kremsi nace de la pasión por los alimentos auténticos. En cada lote, combinamos técnicas tradicionales con innovación para crear un yogurt griego excepcionalmente cremoso y nutritivo.",
  "about.paragraph2": "Seleccionamos cuidadosamente cada ingrediente. Nuestro proceso artesanal respeta el tiempo de fermentación natural, logrando una textura inigualable y un perfil de sabor que celebra la pureza de lo natural.",
  "about.paragraph3": "Somos una empresa costarricense comprometida con la excelencia. Cada producto que lleva nuestro nombre es el resultado de dedicación, conocimiento y un profundo respeto por la tradición griega.",

  // Presentations
  "presentations.title": "Nuestras presentaciones",
  "presentations.size_130": "130 g",
  "presentations.size_130_desc": "Ideal para disfrutar en cualquier momento. Perfecto para llevar al trabajo, la universidad o después del gimnasio.",
  "presentations.size_440": "440 g",
  "presentations.size_440_desc": "Ideal para compartir en familia. El tamaño perfecto para tener siempre en casa y disfrutar cada día.",
  "presentations.size_950": "950 g",
  "presentations.size_950_desc": "Ideal para hogares, cafeterías y restaurantes. La opción más generosa para los verdaderos amantes del yogurt griego.",

  // Catalog
  "catalog.title": "Nuestro catálogo",
  "catalog.tab_130": "130 g",
  "catalog.tab_440": "440 g",
  "catalog.tab_950": "950 g",
  "catalog.modal_close": "Cerrar",
  "catalog.ingredients": "Ingredientes destacados",
  "catalog.benefits": "Beneficios",
  "catalog.storage": "Modo de conservación",
  "catalog.consumption": "Forma de consumo",
  "catalog.presentation": "Presentación",

  // Products 130g
  "product.berries.name": "Berries",
  "product.berries.desc": "Yogurt griego deslactosado con una mezcla de frutos rojos seleccionados.",
  "product.chocolate.name": "Chocolate",
  "product.chocolate.desc": "Yogurt griego deslactosado con auténtico chocolate costarricense.",
  "product.cas.name": "Cas",
  "product.cas.desc": "Yogurt griego deslactosado con el sabor tropical del cas costarricense.",
  "product.strawberry.name": "Fresa",
  "product.strawberry.desc": "Yogurt griego deslactosado con fresas frescas cuidadosamente seleccionadas.",
  "product.mango_maracuya.name": "Mango Maracuyá",
  "product.mango_maracuya.desc": "Yogurt griego deslactosado con la combinación tropical perfecta de mango y maracuyá.",
  "product.pina_colada.name": "Piña Coco",
  "product.pina_colada.desc": "Yogurt griego deslactosado con el refrescante sabor de piña y coco.",
  "product.sandia.name": "Sandía",
  "product.sandia.desc": "Yogurt griego deslactosado con el sabor refrescante y dulce de la sandía.",
  "product.taro.name": "Taro",
  "product.taro.desc": "Yogurt griego deslactosado con el delicado y exquisito sabor del taro.",
  "product.vainilla.name": "Vainilla",
  "product.vainilla.desc": "Yogurt griego deslactosado con vainilla natural. Un clásico irresistible.",
  "product.coco.name": "Base de Coco",
  "product.coco.desc": "Yogurt tipo griego vegano a base de coco. Cremoso y completamente vegetal.",

  // Products 440g
  "product.natural.name": "Natural",
  "product.natural.desc": "Yogurt griego deslactosado natural. La expresión más pura de nuestra tradición artesanal.",

  // Why Choose
  "why.title": "¿Por qué elegir Kremsi?",
  "why.ingredients": "Ingredientes naturales",
  "why.ingredients_desc": "Solo ingredientes reales, nada artificial. La naturaleza en su forma más pura.",
  "why.no_preservatives": "Sin conservadores",
  "why.no_preservatives_desc": "Frescura auténtica sin aditivos. Como debe ser un yogurt de verdad.",
  "why.lactose_free": "Deslactosado",
  "why.lactose_free_desc": "Toda la cremosidad del yogurt griego sin lactosa. Para que todos puedan disfrutar.",
  "why.protein": "Alto en proteína",
  "why.protein_desc": "Nutrición real en cada cucharada. Ideal para un estilo de vida activo y saludable.",
  "why.artisanal": "Producción artesanal",
  "why.artisanal_desc": "Pequeños lotes, gran dedicación. Cada yogurt es elaborado con cuidado artesanal.",
  "why.local": "Hecho en Costa Rica",
  "why.local_desc": "Orgullosamente costarricense. Apoyamos productores locales y la economía de nuestro país.",

  // Locations
  "locations.title": "Dónde encontrarnos",
  "locations.subtitle": "Nuestros productos están disponibles en supermercados seleccionados de Costa Rica.",
  "locations.whatsapp": "Consultar disponibilidad por WhatsApp",

  // Instagram
  "instagram.title": "Síguenos en Instagram",
  "instagram.subtitle": "Descubre recetas, novedades y el día a día de Kremsi.",
  "instagram.follow": "Seguir en Instagram",

  // Contact
  "contact.title": "Contacto",
  "contact.subtitle": "Estamos aquí para ti. Escríbenos y te responderemos lo antes posible.",
  "contact.whatsapp": "WhatsApp",
  "contact.email": "Correo",
  "contact.hours": "Horario",
  "contact.hours_value": "Lunes a Viernes: 8:00 AM - 5:00 PM",
  "contact.location": "Ubicación",
  "contact.location_value": "Guadalupe, San José",
  "contact.form_name": "Nombre",
  "contact.form_email": "Correo",
  "contact.form_message": "Mensaje",
  "contact.form_send": "Enviar consulta",
  "contact.form_success": "¡Gracias por tu mensaje! Te responderemos pronto.",
  "contact.form_error": "Hubo un error al enviar. Intenta nuevamente.",

  // Footer
  "footer.description": "Yogurt griego artesanal costarricense. Elaborado con ingredientes seleccionados, sin conservadores y con el auténtico sabor de lo natural.",
  "footer.quick_links": "Enlaces rápidos",
  "footer.rights": "Todos los derechos reservados.",

  // Shared
  "language.es": "ES",
  "language.en": "EN",
  "site.name": "Kremsi",
};

export default es;